import React, { createContext, useReducer, useEffect } from 'react'
import { useUser } from '@fs/zion-user'
import { useUpdatePlaylist } from '../hooks/preferencesHooks'

export const PlaylistContext = createContext()

const initialState = {
  status: 'REQUEST_PLAYLIST',
  playlist: [],
  pending: false,
}

function stateReducer(state, { type, value }) {
  switch (type) {
    case 'REQUEST_PLAYLIST':
      return { ...state, status: 'REQUEST_PLAYLIST' }
    case 'PLAYLIST_REQUESTED':
      return { ...state, status: 'PLAYLIST_REQUESTED' }
    case 'PLAYLIST_LOADED':
      return { ...state, status: 'PLAYLIST_LOADED', playlist: value }
    case 'PLAYLIST_LOCALLY_REFRESHED':
      return { ...state, status: 'PLAYLIST_LOCALLY_REFRESHED', playlist: value }
    default:
      return { ...state, status: 'INITIAL' }
  }
}

export function PlaylistProvider({ children }) {
  const user = useUser()
  const [updatePlaylist, updateRequestState] = useUpdatePlaylist()
  const [state, dispatch] = useReducer(stateReducer, initialState)

  useEffect(() => {
    if (user?.cisId && state.status === 'REQUEST_PLAYLIST' && !updateRequestState.pending) {
      // debugger
      updatePlaylist({ method: 'GET' })
      dispatch({ type: 'PLAYLIST_REQUESTED' })
    }
  }, [updateRequestState.pending, state.status, updatePlaylist, user.cisId])

  useEffect(() => {
    if (!user?.signedIn && !user.userLoading) {
      dispatch({ type: 'PLAYLIST_LOADED' })
    }
  }, [user.signedIn, user.userLoading])

  useEffect(() => {
    if (updateRequestState.complete && !updateRequestState.pending) {
      dispatch({ type: 'PLAYLIST_LOADED', value: updateRequestState.response?.playlistItems ?? [] })
    }
  }, [updateRequestState.complete, updateRequestState.pending, updateRequestState.response])

  const removePlaylistItem = (playlistItem) => {
    return updatePlaylist({ playlistItem, method: 'DELETE' })
  }

  const addPlaylistItem = (playlistItem) => {
    return updatePlaylist({ playlistItem, method: 'PUT' })
  }

  return (
    <PlaylistContext.Provider value={{ ...state, updateRequestState, dispatch, addPlaylistItem, removePlaylistItem }}>
      {children}
    </PlaylistContext.Provider>
  )
}
